import { ChangeDetectionStrategy, Component, OnInit, OnDestroy } from '@angular/core';
import { UsersService } from '../../services/users.service';
import { UserRoles } from '../../../../SGRE-shared/constants/app-constant';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { Observable, of, Subject, takeUntil } from 'rxjs';
import { User } from '../../model/user-page-model';
import { UserStateInitial } from '../../store/user-data.state';
import { UsersTrackingService } from '../../services/users-tracking.service';
import { StorageService } from '../../../../SGRE-shared/services/storage.service';
import { LegalEntity } from '../../../../SGRE-shared/models/legalEntityList.model';

@Component({
  selector: 'app-invite-users-table',
  templateUrl: './invite-users-table.component.html',
  styleUrl: './invite-users-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class InviteUsersTableComponent implements OnInit, OnDestroy {

  // ootb
  userData$: Observable<UserStateInitial>;
  customerAdminRole$: Observable<boolean>;
  SGREAmdinRole$: Observable<boolean>;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private userService: UsersService,
    private globalService: GlobalService,
    private userstrackingService: UsersTrackingService,
    private storageService: StorageService,
  ) { }

  // ootb
  ngOnInit() {
    this.loadsessionvalues();
    this.loadUsersData();
    this._getuserdata();
    this.loadTrackingEvent();
  }

  loadsessionvalues(): void {
    const userRoles: string[] = this.globalService.getUserRoles();
    this.customerAdminRole$ = of(userRoles.some((role: string) => role === UserRoles.CUSTOMER_ADMIN));
    this.SGREAmdinRole$ = of(userRoles.some((role: string) => role === UserRoles.SGRE_ADMIN));
  }

  loadUsersData(): void {
    this.globalService.loadingSubject.next(true);
    const paramsObject = { currentPage: 0, fields: User.BASIC, pageSize: 20 };
    this.userService.loadUserData(paramsObject);
  }

  _getuserdata(): void {
    this.userData$ = this.userService.getUserData();
    this.userService.getUserData().pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      this.userService.filteredData = data.userstableData
    })
  }

  loadTrackingEvent(): void {
    let defaultLegalEntity: LegalEntity = this.storageService.defaultLegalEntity;
    this.userstrackingService.pageLoadTrackingData(defaultLegalEntity);
  }

  onFilter(data): void {
    this.userService.filteredData = data.filteredData;
  }

  navigateUserProfile(data): void {
    this.userService.navigateUserProfile(data);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(undefined);
    this.unsubscribe$.complete();
    this.globalService.clearMessagesOnDestroy();
  }

  // OLD CODE
  // ngOnInit() {
  //   const legalEntitiesSubscription = this.store.pipe(select(selectUserLegalEntities)).subscribe((legalEntities) => {
  //     this.legalEntities = legalEntities ? legalEntities : [];
  //     this.getsessionvalues();
  //     this.globalService.loadingSubject.next(true);
  //     let paramsObject = { currentPage: 0, fields: 'BASIC', pageSize: 20 };
  //     this.userService.userData(paramsObject);
  //     //this.userService.userssgredetails()
  //      this.getuserdata();

  //   });
  // }

  // createTableSGREConfiguration(userdata) {
  //   let legalentities = [];
  //   let defaultlegalentities = [];
  //   userdata.map((x: any) => {
  //     if (x.displayName != undefined) {
  //       this.displayname.push({ displayName: x.displayName });
  //     }
  //     if (x.company != undefined) {
  //       this.company.push({ company: x.company });
  //     }
  //     if (x.email != undefined) {
  //       this.username.push({ email: x.email });
  //     }
  //     if (x.alternativeEmail != undefined) {
  //       this.alternativeEmail.push({ alternativeEmail: x.alternativeEmail });
  //     }
  //   });
  //   let company = this.company.reduce((unique, o) => {
  //     if (!unique.some((obj) => obj.company === o.company)) {
  //       unique.push(o);
  //     }
  //     return unique;
  //   }, []);
  //   let alternativeemail = this.alternativeEmail.reduce((unique, o) => {
  //     if (!unique.some((obj) => obj.alternativeEmail === o.alternativeEmail)) {
  //       unique.push(o);
  //     }
  //     return unique;
  //   }, []);
  //   let paramsObject = { currentPage: 0, fields: 'FULL', pageSize: 20, userID: this.globalService.getUserId() };
  //   this.userService.getlegalentities(paramsObject)
  //     .subscribe((data1: any) => {
  //       this.legaldata = [...data1.legalEntities];
  //       this.legaldata.map((j: any) => {
  //         j.roles.filter((l: any) => {
  //           if (this.role === 'Customer Admin') {
  //             if (l === 'Customer Admin') {
  //               defaultlegalentities.push(j.uid);
  //               let data = { uid: j.uid, legalEntityCount: j.name };
  //               this.legaldataFilteroptions.push(data);
  //               this.sgredetails = this.sgredetails.map((x: any) => {
  //                 let userlegalentities = x.legalEntityList;

  //                 userlegalentities = userlegalentities.filter((element) =>
  //                   defaultlegalentities.includes(element)
  //                 );
  //                 x['legalEntityCount'] = userlegalentities.length;
  //                 return x;
  //               });
  //             }
  //           }
  //           if (this.role === 'SGRE Admin') {
  //             let data = { uid: j.uid, legalEntityCount: j.name };
  //             this.legaldataFilteroptions.push(data);
  //           }
  //         });
  //       });
  //     });
  //   let columnData = [
  //     {
  //       label: 'Name',
  //       name: 'displayName',
  //       type: ColumnType.link,
  //       filter: true,
  //       filterOptions: this.displayname,
  //     },
  //     {
  //       label: 'Username',
  //       name: 'email',
  //       type: ColumnType.link,
  //       filter: true,
  //       filterOptions: this.username,
  //     },
  //     {
  //       label: 'Alternative Email',
  //       name: 'alternativeEmail',
  //       type: ColumnType.text,
  //       filter: true,
  //       filterOptions: alternativeemail,
  //     },
  //     {
  //       label: 'Company',
  //       name: 'company',
  //       type: ColumnType.text,
  //       filter: true,
  //       filterOptions: company,
  //     },
  //     {
  //       label: 'Legal Entities',
  //       name: 'legalEntityCount',
  //       type: ColumnType.number,
  //       filter: true,
  //       filterOptions: this.legaldataFilteroptions,
  //     },
  //   ];
  //   this.columns = columnData.map((item) => new Column(item));
  // }

  // navigate(data) {
  //   this.store.dispatch(StorageActions.setUserProfileData({ userProfileData: 'users' }));
  //   this.router.navigate([AppConstants.routeUrls.userProfile], {
  //     queryParams: { user: data },
  //   });
  // }

  //old code

  // getuserdata() {
  //   this.globalService.loadingSubject.next(true);

  // this.userService.userssgredetails()
  //   .subscribe((data: any) => {
  //     console.log('main data',data)
  //     this.sgredetails = data?.map((item) => {
  //       item['navigateUrl'] = item.userId
  //       let legalEntites = [];
  //       item?.legalEntityList?.forEach(item => legalEntites.push(this.findLegalEntityName(item)))
  //       item['legalEntityNames'] = legalEntites;
  //       return item;
  //     });
  //       this.userService.filteredData = this.sgredetails;
  //       this.masterSgreDetails = JSON.parse(JSON.stringify(this.sgredetails));
  //       this.createTableSGREConfiguration(this.masterSgreDetails);
  //       this.globalService.loadingSubject.next(false);
  //       this.changeRef.markForCheck();
  //     });
  // }
  // findLegalEntityName(uid) {
  //   return this.legalEntities?.find(item => item.uid === uid)?.name;
  // }
}
